import { FC } from 'react';
import { Input } from 'reactstrap';

interface Props {
  allSelected: boolean;
  someSelected: boolean;
  onSelectAll: (checked: boolean) => void;
}

const ApplicantRowHeader: FC<Props> = ({
  allSelected,
  someSelected,
  onSelectAll,
}) => (
  <div className="ai-console__row-header ai-console__row-grid">
    <div className="ai-console__col-check">
      <Input
        type="checkbox"
        checked={allSelected}
        // indeterminate is not a standard HTML attr; set via ref in real impl
        onChange={(e) => onSelectAll(e.target.checked)}
        title={allSelected ? 'Deselect all' : 'Select all'}
      />
    </div>
    <div className="ai-console__col-avatar" />
    <div className="ai-console__col-candidate">Candidate</div>
    <div className="ai-console__col-contact">Contact</div>
    <div className="ai-console__col-company">Current company / title</div>
    <div className="ai-console__col-fit">Fit</div>
    <div className="ai-console__col-recommendation">Recommendation</div>
    <div className="ai-console__col-status">Status</div>
    <div className="ai-console__col-trail" />
  </div>
);

export default ApplicantRowHeader;
